import React from 'react'
import FooterCategory from './footer-category'
import FooterCategoryMobile from './mobile-footer-category'
import classNames from 'classnames'

interface FooterSectionProps {
  section: {
    label: string
    childItems: {
      nodes: Array<{
        label: string
        childItems: {
          nodes: Array<{
            label: string
            uri: string
            cssClasses: string
          }>
        }
      }>
    }
  }
  isTopSection?: boolean
};

const FooterSection: React.FC<FooterSectionProps> = ({ section, isTopSection }: FooterSectionProps) => {
  return (
    <>
      <div className={classNames({ 'footer-section': true, 'top-footer-section': isTopSection })}>
        {section?.label !== 'Rula' && <h6>{section?.label}</h6>}
        <div className='category-container'>
          {section?.childItems.nodes.map((item, i) => (
            <React.Fragment key={i}>
              <FooterCategory title={item.label} items={item.childItems.nodes} isTopSection={isTopSection} />
              <FooterCategoryMobile title={item.label} items={item.childItems.nodes} isTopSection={isTopSection} />
            </React.Fragment>
          ))}
        </div>
      </div>
      <hr className='footer-divider' />
    </>
  )
}

export default FooterSection
